import {
  ROLE_ANALYST,
  ROLE_ANALYST_ADMIN,
} from "../../../components/constants";

import VerticalLayout from "./../../../components/VerticalLayout";

import DataProtectionSoftwareMainPage from "../pages/admin/software";
import DataProtectionSoftwareDetails from "../pages/admin/software/details";
import DataProtectionHardwareList from "../pages/admin/hardware";
import DataProtectionHardwareCreate from "../pages/admin/hardware/create";
import DataProtectionHardwareDetails from "../pages/admin/hardware/details";
import DataProtectionListReports from "../pages/admin/reports/list";
import DataProtectionProcessingDirectoryList from "../pages/admin/processing-directory/list";
import NewsPage from "../pages/admin/news/tabs-content/latest-news";
import DataProtectionControlsList from "../pages/admin/controls/list";
import DataPorotectionControlTasksList from "../pages/admin/controls/tasks";
import DataProtectionTaskDetailPage from "../pages/admin/tasks/details";
import DataProtectionQuestionnairesList from "../pages/admin/administration/questionaire";
import DataProtectionAdministrationSettings from "../pages/admin/administration/settings";
import DataProtectionInstallDeviceAgent from "../pages/common/device-agent";
import DataProtectionAdministrationCustomization from "../pages/admin/administration/customization";
import DataProtectionHistoryLog from "../pages/admin/administration/history-log";
// import LatestNewsDetails from "../pages/admin/software/details/tabs-content/latest-news/details";
import incidentRegister from "../pages/admin/incident-register";
import AddNewIncident from "../pages/admin/incident-register/new";
import IncidentDetails from "../pages/admin/incident-register/details";
import DataSubjectRequest from "../pages/admin/data-subject-request";
import AddNewDataSubjectRequest from "../pages/admin/data-subject-request/new";
import DataSubjectDetails from "../pages/admin/data-subject-request/details";
import Dashboard from "../pages/admin/dashboard";
import news from "../pages/admin/news";
import IndexKanban from "../pages/admin/kanban-board";
import TOMS from "../pages/admin/toms";
import AddNewTOM from "../pages/admin/toms/pages/create";
import TOMDetails from "../pages/admin/toms/pages/details";
import UserManual from "../pages/UserManual";
/**
 * Internal documents
 */
import AppDocuments from "../pages/admin/administration/documents";
/**-------------------------------- */
import Documents from "../pages/admin/documents";
import DataProtectionUserManagement from "../pages/admin/administration/user-management";
import DataProtectionUserFunctionDetails from "../pages/admin/administration/user-management/function-details";
import NewUser from "src/pages/Admin/administration/user-management/new-user";
import EditUser from "src/pages/Admin/administration/user-management/EditUser";

import OtherAssetsMainPage from "../pages/admin/other-assets";
import OtherAssetsCreate from "../pages/admin/other-assets/create";
import OtherAssetsDetails from "../pages/admin/other-assets/details";

import {
    ROUTE_PATH_ADMIN_CONTROLS_LIST,
    ROUTE_PATH_ADMIN_CONTROL_TASKS_LIST,
    ROUTE_PATH_ADMIN_TASK_DETAIL_PAGE,
    ROUTE_PATH_ADMIN_DOCUMENTS_LIST,
    ROUTE_PATH_ADMIN_OTHER_ASSETS_LIST,
    ROUTE_PATH_ADMIN_USER_FUNCTION_DETAILS,
} from "src/modules/data-protection/constants";

const dataProtectionRoutes = [
	{
		path: "/admin/data-protection/user_manual",
		component: UserManual,
		layout: VerticalLayout,
		type: "admin",
		modules: ["gd"]
	},
	{
		path: "/admin/data-protection/dashboard",
		component: Dashboard,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Dashboard | SIP"
	},
	{
		path: "/admin/data-protection/kanban-board",
		component: IndexKanban,
		layout: VerticalLayout,
		type: "admin",
		modules: ["gd"]
	},
	{
		path: "/admin/data-protection/softwares/:softwareId",
		component: DataProtectionSoftwareDetails,
		layout: VerticalLayout, 
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Software Details | SIP"
	},
	{
		path: "/admin/data-protection/softwares",
		component: DataProtectionSoftwareMainPage,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Software List | SIP"
	},
	{
		path: "/admin/data-protection/hardwares/create",
		component: DataProtectionHardwareCreate,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Create Hardware | SIP"
	},
	{
		path: "/admin/data-protection/hardwares/:hardwareId",
		component: DataProtectionHardwareDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Hardware Details | SIP"
	},
	{
		path: "/admin/data-protection/hardwares",
		component: DataProtectionHardwareList,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Hardware List | SIP"
	},
    {
		path: "/admin/data-protection/other-assets/create",
		component: OtherAssetsCreate,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Create Other Asset | SIP"
	},
	{
		path: "/admin/data-protection/other-assets/:assetId",
		component: OtherAssetsDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Other Asset Details | SIP"
	},
	{
		path: ROUTE_PATH_ADMIN_OTHER_ASSETS_LIST,
		component: OtherAssetsMainPage,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Hardware List | SIP"
	},
	{
		path: "/admin/data-protection/reports",
		component: DataProtectionListReports,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Case Management | SIP"
	},
	{
		path: "/admin/data-protection/processing-directory",
		component: DataProtectionProcessingDirectoryList,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Processing Directory | SIP"
	},
    {
		path: ROUTE_PATH_ADMIN_CONTROL_TASKS_LIST,
		component: DataPorotectionControlTasksList,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Control Tasks | SIP"
	},
    {
		path: ROUTE_PATH_ADMIN_CONTROLS_LIST,
		component: DataProtectionControlsList,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Controls | SIP"
	},
    {
		path: ROUTE_PATH_ADMIN_TASK_DETAIL_PAGE,
		component: DataProtectionTaskDetailPage,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Task Details | SIP"
	},
    {
		path: ROUTE_PATH_ADMIN_DOCUMENTS_LIST,
		component: Documents,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Documents | SIP"
	},
	{
		path: "/admin/data-protection/administration/customization",
		component: DataProtectionAdministrationCustomization,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Cistomization | SIP"
	},
	{
		path: "/admin/data-protection/administration/history-logs",
		component: DataProtectionHistoryLog,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "History logs | SIP"
	},
	{
		path: "/admin/data-protection/administration/settings",
		component: DataProtectionAdministrationSettings,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Settings | SIP"
	},
    {
		path: "/admin/data-protection/administration/device-agent",
		component: DataProtectionInstallDeviceAgent,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Install Windows Device Agent | SIP"
	},
	{
		path: ROUTE_PATH_ADMIN_USER_FUNCTION_DETAILS,
		component: DataProtectionUserFunctionDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Function Details | SIP"
	},
	{
		path: "/admin/data-protection/administration/users/:id/edit",
		component: EditUser,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"]
	},
	{
		path: "/admin/data-protection/administration/users/add",
		component: NewUser,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"]
	},
	{
		path: "/admin/data-protection/administration/users",
		component: DataProtectionUserManagement,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "User Management"
	},
	{
		path: "/admin/data-protection/administration/questionnaire",
		component: DataProtectionQuestionnairesList,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Questionnaire | SIP"
	},
    {
        path: "/admin/data-protection/administration/documents",
        component: AppDocuments,
        layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Questionnaire | SIP"
    },
	{
		path: "/admin/data-protection/toms/create",
		component: AddNewTOM,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "TOM | SIP"
	},
	{
		path: "/admin/data-protection/toms/:id/details",
		component: TOMDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Incident Register | SIP"
	},
	{
		path: "/admin/data-protection/toms",
		component: TOMS,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "TOM | SIP"
	},
	{
		path: "/admin/data-protection/news",
		component: NewsPage,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "News | SIP"
	},
	// {
	// 	path: "/admin/data-protection/latest-news/details/:id",
	// 	component: LatestNewsDetails,
	// 	layout: VerticalLayout,
	// 	type: "admin",
	// 	roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
	// 	modules: ["gd"],
	// 	title: "Latest News | SIP"
	// },
	{
		path: "/admin/data-protection/latest-news",
		component: news,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN, ROLE_ANALYST],
		modules: ["gd"],
		title: "Latest News | SIP"
	},
	{
		path: "/admin/data-protection/incident-register/details/:caseId",
		component: IncidentDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Incident Register | SIP"
	},
	{
		path: "/admin/data-protection/incident-register/create",
		component: AddNewIncident,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Incident Register  SIP"
	},
	{
		path: "/admin/data-protection/incident-register",
		component: incidentRegister,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Incident Register  SIP"
	},
	{
		path: "/admin/data-protection/data-subject-request/details/:caseId",
		component: DataSubjectDetails,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Data Subject | SIP"
	},
	{
		path: "/admin/data-protection/data-subject-request/create",
		component: AddNewDataSubjectRequest,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Data Subject Request | SIP"
	},
	{
		path: "/admin/data-protection/data-subject-request",
		component: DataSubjectRequest,
		layout: VerticalLayout,
		type: "admin",
		roles: [ROLE_ANALYST_ADMIN],
		modules: ["gd"],
		title: "Data Subject | SIP"
	}
];

export default dataProtectionRoutes;
